// eslint-disable-next-line import/no-unresolved
import * as processInclude from 'base/util';
import quantityDetail from './product/components/quantityDetail';

$(document).ready(() => {
    processInclude(quantityDetail);
});
